var render = function render(){var _vm=this,_c=_vm._self._c;return _c('master-main',{attrs:{"addProperties":{
    eventType: 1,
    routeToCreate: _vm.getModuleRoute,
  },"exportProperties":{
    pdf: {
      filename: `${_vm.$t('sigatoka.sigatoka_config')}_${_vm.dateToday}.pdf`,
      route: `${_vm.getModuleRoute}/pdf`,
    },
    xls: {
      filename: `${_vm.$t('sigatoka.sigatoka_config')}_${_vm.dateToday}.xlsx`,
      route: `${_vm.getModuleRoute}/excel`,
    },
  },"dataBadges":[
    {
      columnLabel: _vm.$t('common_words.associated_companies2'),
      data: 'businesses',
      property: 'name',
      minWidth: 180,
    },
  ],"route":_vm.getModuleRoute,"showProperties":_vm.showProperties,"tableProperties":_vm.tableProperties},on:{"refresh":_vm.refresh,"showHideLoading":_vm.showHideLoading,"showNotification":_vm.notifyVue}})
}
var staticRenderFns = []

export { render, staticRenderFns }